<template>
  <div id="Competition" class="Competition">
    <v-dialog v-model="competitionDialog" persistent max-width="700" v-if="competionIsOver">
        <template v-slot:activator="{ on }">
            <v-btn  color="primary" small fixed dark fab bottom left dark v-on="on" class="pulse Competition__trigger">
                <v-icon>mdi-license</v-icon>
            </v-btn>
        </template>
        <v-card class="Competition__cover" :class="{'part3': part3}">
          <v-btn class="Competition__close" small fab @click="closeModal"><v-icon>mdi-close</v-icon></v-btn>
          <div class="Competition__coverPart Competition__coverPart1" v-if="part1 === true">
            <h1 class="Competition__title">🎉 Are you up for a challenge? 🎉</h1>
            <h2 class="Competition__titlesub">THE FOUNDERS OF MYPABOX AND @URBANESCRUBS ARE GIVING AWAY A $500 SCHOLARSHIP AND EDUCATION SUPPORT PACKAGE TO ONE LUCKY WINNER</h2>
            
            <h1 class="Competition__titleHash pulse">#MYPABOXVIDEOCHALLENGE </h1>
            <ul>
              <li>Use the platform of your choice (Instagram, TikTok, Snapchat, YouTube) to create a video showcasing myPAbox or its logo⁣⁣</li>
              <li>Be creative and #thinkoutsideofthebox… humor is encouraged; think along the lines of skits, dances, raps, poems, bloopers, etc.⁣</li>
            </ul>
            <v-card-actions class="mt-4 justify-center flex-wrap">
              <v-btn class="mx-2 mb-4" color="darken-1" @click="showStep('part2')">Rules for entry</v-btn>
              <v-btn href="https://docs.google.com/forms/d/e/1FAIpQLSdMTkoGZCfFxK_STfGItITx2JJu9W5Ift9ZD6bykMAmQipmug/viewform" target="_blank" class="mx-2 mb-4" color="primary">Enter Giveaway</v-btn>
            </v-card-actions>
            <p class="Competition__description">Contest ends <strong>7/15/20</strong></p>
          </div>

          <div class="Competition__coverPart Competition__coverPart2"  v-if="part2 === true">
            <v-btn class="Competition__back" small fab @click="goBack"><v-icon>mdi-arrow-left</v-icon></v-btn>
            <h1 class="Competition__titleHash pulse">#MYPABOXVIDEOCHALLENGE </h1>
            <h4 class="Competition__titleMini">RULES FOR ENTRY</h4>
            <ul>
              <li>Video must be at least 30 seconds in length and uploaded to your social media page of choice (either to your IGTV & tag @mypabox + @urbanescrubs, Tiktok & tag @mypabox + @urbanescrubs, YouTube account)</li>
              <li>Hashtag #mypaboxvideochallenge #urbanescrubs </li>
              <li>Fill out the form located on www.myPAbox.com (it’s brief, don’t worry) - link in our bio</li>
              <li>Open to all future and current healthcare providers⁣</li>
              <li>Open to all future and current healthcare providers</li>
              <li>Multiple entries are allowed</li>
              <li>Winner will be chosen by the myPAbox founders based upon creativity, humor, and originality</li>
              <li>Contest ends 7/15/20 at 11:59 PM EST. Winner will be announced 7/17/20. This giveaway is not affiliated with or sponsored by Instagram.</li>
            </ul>
            <h4 class="Competition__titleMini">$500 SCHOLARSHIP MAY BE USED AS YOU SEE FIT:</h4>
            <p> Application fees, interview costs, admissions testing, textbooks, subscriptions, study materials, CMEs, medical supplies, licensure/certification fees, etc." </p>
          </div>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data () {
    return {
      showAll: false,
      competionIsOver: false,
      competitionDialog: false,
      part1: true,
      part2: false,
      part3: false
    }
  },
  methods: {
    readAllShow () {
      console.log('aaa')
      this.showAll = true
    },
    showStep (event) {
      console.log(event)
      this.part1 = false
      this.part2 = false
      this.part3 = false
      this[event] = true
      console.log(event, this.part1, this.part2, this.part3)
    },
    goBack () {
      this.part1 = true
      this.part2 = false
      this.part3 = false
    },
    closeModal () {
      this.competitionDialog = false
      this.goBack()
    },
    checkTheTiming () {
      const now = new Date().getTime()
      const end = new Date("July 15, 2020 23:59:00").getTime()
      const days = end - now
      /*
      var offset = new Date().getTimezoneOffset();// getting offset to make time in gmt+0 zone (UTC) (for gmt+5 offset comes as -300 minutes)
      var date = new Date();
      date.setMinutes ( date.getMinutes() + offset);// date now in UTC time
      var easternTimeOffset = -240; //for dayLight saving, Eastern time become 4 hours behind UTC thats why its offset is -4x60 = -240 minutes. So when Day light is not active the offset will be -300
      date.setMinutes ( date.getMinutes() + easternTimeOffset);
      */

      return days > 0 ? true : false
    },
    checkTheSessionStorage () {
      const showPopup = sessionStorage.getItem("showPopup");
      if ( showPopup === null ) {
        sessionStorage.setItem("showPopup", "true");
        return true
      } else {
        return false
      }
    },
    toShowPopup () {
      return this.checkTheSessionStorage() && this.checkTheTiming()
    }
  },
  computed: {
  },
  watch : {
  },
  mounted () {
    this.competionIsOver = this.checkTheTiming()
    this.competitionDialog = this.toShowPopup()
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

  h1, h2, h3, h4, p, div {
    font-family: 'Poppins', sans-serif;
  }

  .Competition__cover {
    padding: 40px 60px;
    position: relative;
  }

  .Competition__cover.part3 {
    min-height: 80vh;
    max-height: 700px;
  }

  .Competition__coverPart3 {
    position: absolute;
    top: 70px;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .Competition__coverPart3 iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
  }

  .Competition__coverPart3 .Competition__back {
    top: -50px;
  }

  .Competition__title {
    text-align: center;
    color: #191340;
  }

  .Competition__titlesub,
  .Competition__titleHash {
    text-align: center;
    color: #191340;
    margin: 30px 0;
  }

  .Competition__titleMini {
    color: #191340;
    margin: 20px 0 0;
  }

  .Competition__close,
  .Competition__back {
    position: absolute;
    right: 20px;
    top: 20px;
  }
  .Competition__back {
    right: auto;
    left: 20px
  }

  .Competition__description {
    text-align: center;
    font-size: 12px;
    margin: 20px 0 0;
  }

  @media (max-width: 900px) {
    .Competition__trigger {
      bottom: 65px !important;
    }

    .Competition__titleHash {
      font-size: 20px;
    }
    .Competition__cover {
      padding: 60px 20px;
    }
  }
  @-webkit-keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
              transform: scale3d(1.05, 1.05, 1.05);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }

  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.05, 1.05, 1.05);
              transform: scale3d(1.05, 1.05, 1.05);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
              transform: scale3d(1, 1, 1);
    }
  }

  .pulse {
    -webkit-animation: pulse ease-in-out 4s infinite 1s;
            animation: pulse ease-in-out 4s infinite 1s;
  }

</style>



// WEBPACK FOOTER //
// src/components/User/Competition.vue